const PERMISSION_KEY= "personalize:pnl_config_system";
const PAGE_URL = {
    PNL_CONFIG_SYSTEM_PAGE: "/admin/personalize/pnl-config-system"
}

export {PERMISSION_KEY, PAGE_URL}

